import {useState} from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

import KPITotalReels from './KPITotalReels';
import KPILoadRemainsPercentBuckets from './KPILoadRemainsPercentBuckets';
import KPIReelDueBuckets from './KPIReelDueBuckets';
import KPIProductInventory from './KPIProductInventory';
import KPIReelTypeTurnRate from './KPIReelTypeTurnRate';
import KPIAverageScrapReturn from './KPIAverageScrapReturn';
import KPIAvgStationaryDays from './KPIAvgStationaryDays';


export default function AnalyticsContainerKPI( props ){
    //console.debug("RTS Break AnalyticsContainerKPI");

    return(
        <>
        <Box id="pageBox">
            <Grid id="dashboardGrid" container spacing={2}>
                <Grid item xs={12} sm={6} md={4} xl={3} xxl={2}>
                    <Box>
                        <KPITotalReels  />
                    </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4} xl={3} xxl={2}>
                    <Box>
                        <KPILoadRemainsPercentBuckets  />
                    </Box>
                </Grid> 
                <Grid item xs={12} sm={6} md={4} xl={3} xxl={2}>
                    <Box>
                        <KPIReelDueBuckets  />
                    </Box>
                </Grid> 
                <Grid item xs={12} sm={6} xxl={4}>
                    <Box>
                        <KPIProductInventory  />
                    </Box>
                </Grid> 
                <Grid item xs={12} sm={6} xxl={4}>
                    <Box>
                        <KPIAverageScrapReturn  />
                    </Box>
                </Grid>
                <Grid item xs={12} sm={6} xxl={4}>
                    <Box>
                        <KPIAvgStationaryDays  />
                    </Box>
                </Grid>                           
                <Grid item xs={12} sm={6} md={4} xl={3} xxl={2}>
                    <Box>
                        <KPIReelTypeTurnRate  />
                    </Box>
                </Grid>         
            </Grid>
        </Box>
        </>   
    );
}
